module.exports = __webpack_public_path__ + "img/hr-sand-dune-decal-08.1e435989.png";